import { Component, OnInit, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'jhi-message',
  template: '<div role="alert"><ng-content></ng-content></div>',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  @HostBinding('class.display-message')
  isInvalid = false;

  @Input()
  error: string;

  @Input()
  controlKey: string;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/message/message.component.ts